import React from 'react';
import { Link } from 'react-router-dom';
import ActionButton from '../components/ActionButton';

export default function NotFoundPage() {
  return (
    <main className="not-found-page">
      <p className="eyebrow">404</p>
      <h1>Page not found</h1>
      <p>The page you are looking for does not exist or may have moved.</p>
      <div className="not-found-actions">
        <ActionButton to="/" variant="primary" size="sm">Back to home</ActionButton>
        <ActionButton to="/menu" variant="outline" size="sm">Browse menu</ActionButton>
      </div>
      <p className="not-found-help">
        Need help? <Link to="/contact">Contact us</Link>
      </p>
    </main>
  );
}
